import selectGroupComponent from './selectGroupComponent.html';

class SelectGroupCtrl {
  state = {
    groupIds: [],
  };

  constructor(PersonaCollection) {
    'ngInject';

    Object.assign(this, { PersonaCollection });
  }

  $onInit() {
    if (!this.ngModel.$viewValue && this.ngRequired) {
      this.ngModel.$setValidity('required', false);
    }
  }

  toggleFilter(name, value) {
    this.ngModel.$setViewValue(this.PersonaCollection.personasDict[value]);
    this.state.groupIds = [value];
    this.dropdownOpened = false;
    this.ngModel.$setValidity('required', true);
  }
}

export default {
  bindings: {
    type: '@',
    options: '<',
    titlePrefix: '<?',
    placeholder: '@',
    ngRequired: '<?',
  },
  require: {
    ngModel: 'ngModel',
  },
  controller: SelectGroupCtrl,
  controllerAs: 'ctrl',
  templateUrl: selectGroupComponent,
};
